module.exports = __webpack_public_path__ + "img/more-horizontal.049c6acc.svg";